// Canonical tier configuration for GeniusList Partner Program
// Single source of truth for all tier-related displays

export const TIERS = [
  {
    id: "bronze",
    name: "Bronze",
    minReferrals: 0,
    maxReferrals: 10,
    commissionRate: 30,
    benefits: [
      "Access to partner dashboard",
      "Basic marketing assets",
      "Monthly payouts",
    ],
  },
  {
    id: "silver",
    name: "Silver",
    minReferrals: 11,
    maxReferrals: 25,
    commissionRate: 35,
    benefits: [
      "All Bronze benefits",
      "Priority email support",
      "Exclusive email templates",
    ],
  },
  {
    id: "gold",
    name: "Gold",
    minReferrals: 26,
    maxReferrals: 50,
    commissionRate: 38,
    benefits: [
      "All Silver benefits",
      "Custom referral landing page",
      "Bi-weekly payouts",
    ],
  },
  {
    id: "platinum",
    name: "Platinum",
    minReferrals: 51,
    maxReferrals: null, // No upper limit
    commissionRate: 40,
    benefits: [
      "All Gold benefits",
      "Dedicated account manager",
      "Weekly payouts & bonuses",
    ],
  },
];

// Helper function to format referral range for display
export const formatReferralRange = (tier) => {
  if (tier.maxReferrals === null) {
    return `${tier.minReferrals}+`;
  }
  return `${tier.minReferrals}-${tier.maxReferrals}`;
};

// Helper function to get tier by id
export const getTierById = (tierId) => {
  return TIERS.find((t) => t.id === tierId.toLowerCase()) || TIERS[0];
};

// Helper function to get tier by referral count
export const getTierByReferrals = (referralCount) => {
  for (let i = TIERS.length - 1; i >= 0; i--) {
    if (referralCount >= TIERS[i].minReferrals) {
      return TIERS[i];
    }
  }
  return TIERS[0];
};

// Helper to get tier badge color classes
export const getTierColorClass = (tierId) => {
  const colors = {
    bronze: "bg-amber-100 text-amber-800",
    silver: "bg-slate-200 text-slate-700",
    gold: "bg-yellow-100 text-yellow-800",
    platinum: "bg-purple-100 text-purple-800",
  };
  return colors[tierId?.toLowerCase()] || colors.bronze;
};

export default TIERS;
